<template>
	<van-popup v-model="show" :position="isMobileFlag?'bottom':'center'" get-container="body" closeable class="bs-popup">
		<div class="bs-popup-head">
			<div class="bs-popup-tit">{{$t('会员等级返利率说明')}}</div>
		</div>
		<div class="bs-popup-scroll">
			<div class="bs-popup-body " style="">
					<div class="vip-desc">{{$t('会员等级返利率描述')}}</div>
					<table class="layui-table layui-align-center">
					  <colgroup>
					    <col width="36%">
					    <col>
					  </colgroup>
					  <thead>
					    <tr>
					      <th>{{$t('等级名称')}}</th>
					      <th>{{$t('等级返利率')}}</th>
					    </tr> 
					  </thead>
					  <tbody>
					    <tr v-for="(item,index) in levelList" :key="index">
					      <td>{{item.level_name}}</td>
					      <td>{{item.proportion}}%</td>
					    </tr>
					  </tbody>
					</table>
				</div>
		</div>
	</van-popup>
	
</template>
<script>
	export default {
		components: {},
		props: {
			levelList: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				show: false
			};
		},
		mounted() {}
	}
</script>